import {
  generatePath,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";

import { parseQuery, stringifyQuery } from "@/utils/query-string";

const LEGACY_PARAMS = [
  "modal_open",
  "m_report",
  "m_searches",
  "m_insight_ids",
  "group_by",
  "m_group_by",
  "mention_media_category",
];

export default function LegacyInsightsRedirect({ url }: { url: string }) {
  // URL state
  const params = useParams<{ orgUuid: string; uuid: string }>();
  const { search } = useLocation();

  // Helpers
  const query = parseQuery<Record<string, unknown>>(search, {
    parseBooleans: false,
    parseNumbers: false,
  });
  LEGACY_PARAMS.forEach((key) => delete query[key]);
  const queryString = stringifyQuery(query);
  const pathname = generatePath(url, params);

  return (
    <Redirect to={queryString ? `${pathname}?${queryString}` : pathname} />
  );
}
